import styled, { TColorsName } from 'styled-components'

import { ButtonProps } from './types'

const Wrapper = styled.button<ButtonProps>`
  position: relative;
  right: 0;
  left: 0;
  margin: auto;
  height: 50px;
  width: ${p => (p.loading ? '50px !important' : '100%')};
  border: ${p =>
    p.variant === 'outline'
      ? `2px solid ${p.theme.colors[p.color as TColorsName] || p.color}`
      : 'none'};
  outline: none;
  color: ${p =>
    p.variant === 'outline'
      ? p.theme.colors[p.color as TColorsName] || p.color
      : p.theme.colors.foreground};
  border-color: ${p => p.theme.colors[p.color as TColorsName] || p.color};
  background: ${p =>
    p.variant === 'outline'
      ? 'transparent'
      : p.theme.colors[p.color as TColorsName] || p.color};
  font-style: normal;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  font-size: 0.9rem;
  font-family: ${p => p.theme.fonts.tertiary};
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  border-radius: ${p => (p.loading ? '50%' : '6px')};

  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    ${p =>
      p.variant === 'outline'
        ? `
      background: ${p.theme.colors[p.color as TColorsName] || p.color};
      color: ${p.theme.colors.foreground};
    `
        : ''}
  }

  ::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 50px;
    z-index: -1;
    opacity: ${p => (p.variant === 'outline' ? 0 : 0.3)};
    filter: blur(5px);
    transition: all 0.2s ease-out;
  }

  :hover::after {
    opacity: ${p => (p.variant === 'outline' ? 0 : 0.5)};
    filter: blur(20px);
    transform: translatey(10px) scalex(1.2);
  }

  :active::after {
    opacity: ${p => (p.variant === 'outline' ? 0 : 0.3)};
  }
`

const Spinner = styled.div<{ variant?: 'solid' | 'outline'; color?: string }>`
  width: 32px;
  height: 32px;
  background: transparent;
  box-sizing: border-box;
  border-top: 1.5px solid
    ${p =>
      p.variant === 'outline'
        ? p.theme.colors[p.color as TColorsName] || p.color || 'currentColor'
        : 'white'};
  border-left: 1.5px solid transparent;
  border-right: 1.5px solid transparent;
  border-bottom: 1.5px solid transparent;
  border-radius: 100%;
  animation: spin 0.8s ease-out infinite;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`

export { Wrapper, Spinner }
